import { useEffect } from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useQuery } from '@apollo/client';
import ReactMarkdown from 'react-markdown';
import { Grid } from 'antd';

import { initializeApollo } from 'lib/apollo/client';
import { COMPLAINTS_PAGE_QUERY, COOKIE_BANNER_QUERY } from 'queries';

import ComplanintForm from './Form';

import { flattenEntities } from 'utils/graphql';
import { useLogoState } from 'context/LogoContext';

import { ContentWrapper } from 'styles/components';
import { PageContainer, Content } from './styles';

export const getStaticProps: GetStaticProps = async () => {
  const { query, cache } = initializeApollo();

  cache.evict({ fieldName: 'complaintsPage' });
  cache.gc();

  const { data } = await query({ query: COOKIE_BANNER_QUERY });
  await query({ query: COMPLAINTS_PAGE_QUERY });

  return {
    props: {
      cookieBanner: data.cookiePolicyModal.data.attributes,
      initialApolloState: cache.extract(),
    },
  };
};

interface ComplaintsPageProps {
  copy: any;
  content: string;
}

export default function ComplaintsPage() {
  const screens = Grid.useBreakpoint();

  const { data } = useQuery(COMPLAINTS_PAGE_QUERY);
  const complaintsPage: ComplaintsPageProps = flattenEntities(
    data?.complaintsPage
  )?.data;

  const { setIsDarkBackground } = useLogoState();
  useEffect(() => {
    setIsDarkBackground(false);
  }, [setIsDarkBackground]);

  const isMobile = screens.md === false;

  return (
    <>
      <Head>
        <title key="title">Shuttle</title>
        <meta
          property="og:url"
          content={`${process.env.NEXTAUTH_URL}/legal/complaints`}
          key="og:url"
        />
      </Head>
      <PageContainer>
        <ContentWrapper $isMobile={isMobile}>
          <Content>
            <ReactMarkdown>{complaintsPage.content}</ReactMarkdown>
            <ComplanintForm copy={complaintsPage.copy} />
          </Content>
        </ContentWrapper>
      </PageContainer>
    </>
  );
}
